<template>
  <v-container fluid fill-height>
    <v-layout
      justify-center
      align-center
    >
      <v-flex xs12 sm10 md7 lg5>
        <v-card class="elevation-1">
          <v-toolbar color="primary">
            <v-btn icon class="white--text" @click="goBack">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title class="white--text">Update Password</v-toolbar-title>
          </v-toolbar>
          <v-form v-model="validPass" ref="form">
            <v-container fluid>
              <v-layout row>
                <v-flex>
                  <v-text-field
                    name="input-8-1"
                    label="New Password"
                    v-model="user.new_password"
                    min="8"
                    :rules="rules.passwordRules"
                    :append-icon="visibility ? 'visibility' : 'visibility_off'"
                    :append-icon-cb="() => (visibility = !visibility)"
                    :type="visibility ? 'password' : 'text'"
                    counter
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex>
                  <v-text-field
                    name="input-8-1"
                    label="Confirm New Password"
                    v-model="confirmNewPass"
                    min="8"
                    :rules="rules.passwordRulesConfirm"
                    :append-icon="visibilityConfirm ? 'visibility' : 'visibility_off'"
                    :append-icon-cb="() => (visibilityConfirm = !visibilityConfirm)"
                    :type="visibilityConfirm ? 'password' : 'text'"
                    counter
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex>
                  <v-text-field
                    name="input-8-1"
                    label="Old password"
                    v-model="user.old_password"
                    min="8"
                    :rules="rules.fieldRules"
                    :append-icon="oldConfrim ? 'visibility' : 'visibility_off'"
                    :append-icon-cb="() => (oldConfrim = !oldConfrim)"
                    :type="oldConfrim ? 'password' : 'text'"
                    counter
                  ></v-text-field>
                  (we need your current password to confirm your changes)
                </v-flex>
              </v-layout>
            </v-container>
            <v-flex>
              <v-btn color="warning" :disabled="!validPass" @click.native="post">Update</v-btn>
            </v-flex>
          </v-form>
        </v-card>
      </v-flex>
          <div row>
            <v-flex>
              <v-alert
                :color="alert.type"
                icon="check_circle"
                :value="alert.status"
                transition="scale-transition"
              >
                {{ alert.message }}
              </v-alert>
            </v-flex>
          </div>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import Spinner from "vue-simple-spinner";
export default {
  components: {
    Spinner
  },
  data() {
    return {
      validPass: true,
      rules: {
        fieldRules: [v => !!v || "Field is required"],
        phoneValidation: [v => /^(\+\d{1,3}[- ]?)?\d{0,20}$/.test(v) || "Phone number is not valid."],
        passwordRules: [
          v => v.length >= 8 || "Password must be at least 8 characters"
        ],
        passwordRulesConfirm: [
          v => v == this.user.new_password || "Password not confirmed"
        ],
      },
      visibility: true,
      visibilityConfirm: true,
      oldConfrim: true,
      confirmNewPass: "",
      user: {
        email: "",
        old_password: "",
        new_password: "",
      },
      alert: {
        status: false,
        message: "",
        type: ""
      },
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    alerting() {
      this.alert.status = !this.alert.status;
      setTimeout(() => {
        this.alert.status = !this.alert.status;
      }, 2500);
    },
    getMe() {
        axios.get('/me')
        .then(res => {
          this.user.email = res.data.email;
        })
      },
    post() {
      axios.post("/change-own-password", this.user)
      .then(res => {
        this.alert.message = "Password has been updated.";
        this.alert.type = "success";
        this.alerting();
        setTimeout(() => {
          this.$auth.destroyToken()
          this.$router.push('/auth/login');
        }, 4000);

      })
      .catch(err => {
        this.alert.message = err.response.data.message
        this.alert.type = "error";
        this.alerting();
      });
    }
  },
  created() {
    this.getMe();
  }
};
</script>

<style>
.input-group {
  color: #28AFAF !important;
}
</style>



// WEBPACK FOOTER //
// src/components/agency/Agencies/AgenciesEditPass.vue